const PRODUCTION_MCP_URL = "https://mcp.carrier.llc/mcp";
const PRODUCTION_HOST = "mcp.carrier.llc";
const URL_TOKEN = /https?:\/\/[^\s"'<>)]+/g;

function pathWithoutTrailingSlash(pathname: string): string {
  let end = pathname.length;
  while (end > 1 && pathname.charCodeAt(end - 1) === 47) end -= 1;
  return pathname.slice(0, end);
}

function parseHttpUrl(value: string): URL | null {
  try {
    const parsed = new URL(value);
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:") return null;
    return parsed;
  } catch {
    return null;
  }
}

/** True when the host and path are the production MCP endpoint. Query strings are ignored. */
export function isProductionMcpUrl(value: string): boolean {
  if (value === PRODUCTION_MCP_URL) return true;
  const parsed = parseHttpUrl(value);
  if (!parsed || parsed.protocol !== "https:" || parsed.hostname !== PRODUCTION_HOST) return false;
  return pathWithoutTrailingSlash(parsed.pathname) === "/mcp";
}

/** True when the URL host is the production MCP host, whatever the path is. */
export function isCarrierMcpHost(value: string): boolean {
  const parsed = parseHttpUrl(value);
  return parsed?.protocol === "https:" && parsed.hostname === PRODUCTION_HOST;
}

function trimTrailingPunctuation(token: string): string {
  let end = token.length;
  while (end > 0) {
    const code = token.charCodeAt(end - 1);
    if (code !== 46 && code !== 44 && code !== 59 && code !== 58) break;
    end -= 1;
  }
  return token.slice(0, end);
}

/** True when a CLI status line contains the production MCP URL as its own URL token. */
export function lineMentionsProductionMcp(line: string): boolean {
  const tokens = line.match(URL_TOKEN);
  if (!tokens) return false;
  for (const token of tokens) {
    if (isProductionMcpUrl(trimTrailingPunctuation(token))) return true;
  }
  return false;
}
